
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CyberSecurityComponent } from './cybersecurity.component';
import { DefaultComponent } from '../default.component';
import { LayoutModule } from '../../../layouts/layout.module';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { UtentiComponent } from './home/utenti.component';
import { TestComponent } from './home/test.component';
import { MailComponent } from './home/mail.component';
import { UtenteComponent } from './home/utente.component';
import { ReportComponent } from './home/report.component';


const routes: Routes = [
    {
        path: "",
        component: DefaultComponent,
        children: [
            {
                path: "",
                component: CyberSecurityComponent,
                children: [

                    { path: 'home', component: HomeComponent },
                    { path: 'utenti', component: UtentiComponent },
                    { path: 'test', component: TestComponent },
                    { path: 'mail', component: MailComponent },
                    { path: 'utente', component: UtenteComponent },
                    { path: 'report', component: ReportComponent },
                    {
                        'path': '',
                        'redirectTo': 'home',
                        'pathMatch': 'full',
                    }

                ]
            }
        ]
    },
];

@NgModule({
    imports: [
        CommonModule, RouterModule.forChild(routes),
        LayoutModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
    ], declarations: [
        CyberSecurityComponent,
        HomeComponent,
        UtentiComponent,
        TestComponent,
        MailComponent,
        UtenteComponent,
        ReportComponent
    ],
    providers: [

    ]
})
export class CyberSecurityModule {
}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/cybersecurity.module.ts